<template>
  <div class="wrapper">
    <div class="contentBox">
      <div class="actionBar">
        标题名称：
        <el-input
          class="searchInput"
          size="small"
          placeholder="请输入标题名称"
          v-model="searchCondition.title"
          clearable
        >
        </el-input
        >&emsp;
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="getData()"
          >查询
        </el-button>
      </div>
      <div class="actBar">
        <el-button
          type="primary"
          size="small"
          @click="
            Object.assign(linkData, $options.data().linkData);
            linkData.ifShow = true;
          "
          >添加考试链接
        </el-button>
      </div>
      <div class="tableContainer">
        <el-table
          :data="dataList"
          border
          style="width: 100%"
          :cell-style="{ padding: '8px 0', fontSize: '14px' }"
        >
          <el-table-column type="selection" width="40px"> </el-table-column>
          <el-table-column
            prop="title"
            label="标题名称"
            width="120px"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            width="240px"
          ></el-table-column>
          <el-table-column prop="url" label="链接地址"> </el-table-column>
          <el-table-column prop="sort" label="权重"> </el-table-column>

          <el-table-column prop="status" label="状态">
            <template slot-scope="{ row, index }">
              <el-switch
                v-model="row.status"
                active-text="上架"
                :active-value="1"
                inactive-text="下架"
                :inactive-value="0"
                @change="
                  (val) => {
                    row.status = val;
                    Object.assign(linkData, row);
                    editLink();
                  }
                "
              >
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="{ row, index }">
              <el-button
                plain
                size="mini"
                class="bluBar"
                @click="
                  Object.assign(linkData, row);
                  linkData.ifShow = true;
                "
                >编辑 </el-button
              ><el-button
                plain
                size="mini"
                class="bluBar"
                @click="deleteLink(row)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->

        <el-row>
          <el-col :span="24">
            <div class="pagination">
              <el-pagination
                @size-change="getData"
                @current-change="getData"
                :current-page.sync="searchCondition.pageNumber"
                :page-sizes="[10, 20, 50, 100]"
                :page-size.sync="searchCondition.pageSize"
                layout="prev, pager, next"
                :total="searchCondition.total"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      title="提示"
      append-to-body
      :visible.sync="linkData.ifShow"
      width="40%"
    >
      <el-form ref="linkForm" :model="linkData" label-width="120px">
        <el-form-item label="标题名称" prop="title">
          <el-input v-model="linkData.title"></el-input>
        </el-form-item>
        <el-form-item label="链接地址" prop="url">
          <el-input v-model="linkData.url"></el-input>
        </el-form-item>
        <el-form-item label="权重" prop="sort">
          <el-input v-model="linkData.sort"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch
            v-model="linkData.status"
            active-text="上架"
            :active-value="1"
            inactive-text="下架"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="linkData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="editLink()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getExamLinkList, editExamLink, deleteExamLink } from "@/api/bus.js";

export default {
  data() {
    return {
      searchCondition: {
        total: 0,
        pageNumber: 1,
        pageSize: 10,
        title: "",
      },
      linkData: {
        ifShow: false,
        title: "",
        url: "",
        status: 0,
        sort: 0,
        id: 0,
      },
      dataList: [],
    };
  },
  computed: {},
  watch: {},
  components: {},

  methods: {
    getData() {
      getExamLinkList(this.searchCondition).then((data) => {
        console.log(data);
        this.dataList = data.rows;
        this.searchCondition.total = data.total;
      });
    },
    editLink() {
      editExamLink(this.linkData).then((data) => {
        if (this.linkData.id) {
          this.$message.success("编辑成功");
        } else {
          this.$message.success("添加成功");
        }
        this.linkData.ifShow = false;
        this.getData();
      });
    },
    deleteLink(row) {
      this.$confirm(`确认删除吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteExamLink({ ids: [row.id] }).then((data) => {
          this.$message.success("删除成功");
          this.getData();
        });
      });
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  font-size: 12px;
  margin: 15px;

  .contentBox {
    background: #fff;
    padding: 20px;

    .actionBar {
      .searchInput {
        width: 20%;
      }

      .saveBar {
        display: inline-block;
        float: right;
      }
    }

    .tableContainer {
      background: #fff;
      padding-top: 20px;
    }

    /deep/ .el-table {
      //   background-color: #000;
      border-bottom: 1px;
    }
  }
}
</style>
